module.exports = __webpack_public_path__ + "r-v3/img/emoti-panic.f9c6ad82.svg";